import { GridColDef } from "@mui/x-data-grid";
import { Box, Chip } from "@mui/material";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Build } from "@mui/icons-material";
import { JOB_SERVICES_ENDPOINT } from "../../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../../contexts/auth";
import { formatMoney, getContrastColor } from "../../../utils";
import { containsStringFilterOperators } from "../../../components/ui/customDataGrid/filterOperators";

export default function JobServicesCatalogList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewJobServices = useHasPermission("service.view_jobservice");

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: t("Title"),
      flex: 1,
      minWidth: 160,
      filterOperators: containsStringFilterOperators(),
      renderCell: (params) => {
        const title = params.row.title || "—";
        const color = params.row.color as string | null | undefined;
        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Chip
              label={title}
              size="small"
              sx={
                color
                  ? {
                      bgcolor: color,
                      color: getContrastColor(color),
                      "& .MuiChip-label": { color: getContrastColor(color) },
                    }
                  : {
                      bgcolor: "rgba(128, 128, 128, 0.25)",
                      color: "text.secondary",
                    }
              }
            />
          </Box>
        );
      },
    },
    {
      // The catalogue price a finished job is billed at. Not filterable:
      // the endpoint offers no price filter, and a column that silently
      // ignores what the user typed is worse than one that doesn't offer it.
      field: "price",
      headerName: t("Price (net)"),
      type: "number",
      width: 140,
      filterable: false,
      valueFormatter: (value) => formatMoney(value),
    },
    {
      field: "unit",
      headerName: t("Unit"),
      width: 100,
      filterable: false,
      valueGetter: (value, row) => row.unit || "—",
    },
    {
      field: "description",
      headerName: t("Description"),
      filterOperators: containsStringFilterOperators(),
      valueGetter: (value, row) => row.description || "—",
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/service/services-catalog/${id}`);
  };

  if (!canViewJobServices) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Build />}
      title={t("Services Catalog")}
      url={JOB_SERVICES_ENDPOINT}
      gridSettingsKey="JOB_SERVICES_CATALOG"
      columns={columns}
      refreshEventName="jobServiceCatalogAdded"
      onRowClick={handleRowClick}
    />
  );
}
